"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import DateFormat from "@/framework/timeformatter";
import API from "@ym-framework/api-utils";
import { Component, Vue } from "vue-property-decorator";
import { WebsocketViewService } from "@/utils/webSocketViewService";
let MessageDetail = class extends Vue {
  constructor() {
    super(...arguments);
    this.webSocketService = WebsocketViewService;
    this.title = this.$t("message_detail.title");
    this.content = {
      title: "",
      date: 0,
      content: ""
    };
  }
  format_time(time) {
    if (time === 0 || time === null) {
      return "--";
    } else {
      return DateFormat.dateformatter(DateFormat.check(time));
    }
  }
  mounted() {
    return __async(this, null, function* () {
      try {
        this.webSocketService._ipcEvent.on(
          "event:pageEvent.logout.refresh",
          (data) => __async(this, null, function* () {
            location.reload();
          })
        );
        let res = this.$route.query;
        if (res.hasOwnProperty("guid")) {
          let response = yield API.get(`api://base.auth/api/v8/message_center/${res.guid}`);
          console.log(response.data);
          this.content = {
            title: response.data.title,
            date: response.data.create_time,
            content: response.data.message
          };
        }
      } catch (error) {
      }
    });
  }
  goBack() {
    this.$router.push("/message_main");
  }
  beforeDestroy() {
    this.webSocketService._ipcEvent.removeAllListeners();
  }
};
MessageDetail = __decorateClass([
  Component({
    components: {}
  })
], MessageDetail);
export {
  MessageDetail as default
};
